<template>

    <div class="bg-secondary py-5">

        <inertia-head title="Register">
        </inertia-head>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col" style="max-width: 360px;">
                    <div class="card rounded-3 shadow border-0">
                        <div class="card-header border-0">{{ __('Register') }}</div>

                        <div class="card-body">

                            <form @submit.prevent="form.post(route('register'))">
                                <text-input :floating="true" label="name" v-model="form.name" :error="form.errors.name" autocomplete="name" autofocus />
                                <text-input :floating="true" label="customer_number" v-model="form.customer_number" :error="form.errors.customer_number" />
                                <text-input type="email" :floating="true" label="email" v-model="form.email" :error="form.errors.email" autocomplete="email" />
                                <text-input type="password" :floating="true" label="password" v-model="form.password" :error="form.errors.password" autocomplete="new-password" />
                                <text-input type="password" :floating="true" label="password_confirmation" v-model="form.password_confirmation" :error="form.errors.password_confirmation" autocomplete="new-password" />
                                <submit-button child-class="w-100" />
                            </form>           

                            <div v-if="route().has('login')">
                                <hr />
                                <inertia-link :href="route('login')">
                                    {{ __('Bereits registriert? Zum Login') }}
                                </inertia-link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import SlimLayout from '@/shared/Layouts/SlimLayout';

    import TextInput from '@/shared/Inputs/TextInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        layout: SlimLayout,
        props: {
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    customer_number: null,
                    email: null,
                    password: null,
                    password_confirmation: null,
                }),
            }
        },
        components: {
            TextInput,
            CheckboxInput,
            SubmitButton,
        },
        computed: {
        },
    }
</script>
